import React, { useCallback } from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { Form, Modal, ModalVariant } from '@patternfly/react-core';
import { saveButtonFooter } from './ModalButtons';
import ModelsContainer from '../Model/ModelsContainer';
import PropTypes from 'prop-types';
import { hasValidInput } from '../Model/ModelUtils';
import { ModelPropType } from '../Model/ModelPropTypes';
import './EditModal.css';
import HelpButton from 'components/Help/HelpButton';
/**
 * @typedef {object} EditItemModalProps
 * @prop {boolean} [isLoading]
 * @prop {boolean} isOpen
 * @prop {string} [saveText]
 * @prop {(item: Record<string, any>) => void} onSave
 * @prop {boolean} [saveEnabled=true]
 * @prop {Record<string, any>} item
 * @prop {(item: Record<string, any>) => void} setItem
 * @prop {Model[]} models
 * @prop {() => void} onCancel
 * @prop {() => void} [onDelete]
 * @prop {boolean} [deleteEnabled]
 * @prop {string} title
 * @prop {string} [size=ModalVariant.small]
 * @prop {string} [help]
 */

/**
 *
 * @param {EditItemModalProps} props
 * @returns {JSX.Element}
 */
const EditItemModal = ({
  isLoading,
  isOpen,
  saveText,
  onSave,
  saveEnabled: saveEnabledIn = true,
  item, setItem,
  models,
  onCancel,
  onDelete,
  deleteEnabled,
  title,
  size = ModalVariant.small,
  help
}) => {
  const T = useTranslation();

  const _onSave = useCallback(() => {
    onSave?.(item);
  }, [onSave, item]);

  const saveEnabled = saveEnabledIn && hasValidInput(item, models);

  return (
    <Modal
      variant={size}
      title={T.localize(title)}
      isOpen={isOpen}
      onClose={isLoading ? null : onCancel}
      appendTo={() => document.body}
      help={help && (<HelpButton file={help} />)}
      footer={saveButtonFooter({
        T,
        onSave: _onSave,
        saveText,
        saveEnabled,
        onDelete,
        deleteEnabled,
        onCancel,
        isLoading
      })}
    >
      <Form id="form" method="dialog">
        <ModelsContainer models={models} data={item} setData={setItem} />
      </Form>
    </Modal>
  );
};

EditItemModal.propTypes = {
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  onSave: PropTypes.func,
  saveEnabled: PropTypes.bool,
  item: PropTypes.object,
  setItem: PropTypes.func.isRequired,
  models: PropTypes.arrayOf(ModelPropType),
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  deleteEnabled: PropTypes.bool,
  title: PropTypes.string,
  size: PropTypes.string,
  help: PropTypes.string
};

export default React.memo(EditItemModal);


/*
      help={help && (<Popover
        headerContent={T.dashboard.editor.inputs.help.title}
        bodyContent={<HelpView file={help} />}
      >
        <Button variant={ButtonVariant.plain} aria-label="Help">
          <Icons.Help />
        </Button>
      </Popover>)}
*/
